import { adminApi, devlopConfigAPi } from "src/api";

const casesTemplate = () => {
    return adminApi.get(`CaseManagement/TemplateLu`)
}

const assignAdmins = () => {
    return adminApi.get(`CaseManagement/AdminUsers`)
}

const adminData = (id, screenName, isAdmin) => {
    return adminApi.get(`CaseManagement/Cases/${id}/${screenName}/${isAdmin}`)
}
const createCase = (obj, method) => {
    if (method != 'update')
        return devlopConfigAPi.post(`CaseManagement/Cases/Case`, obj)
    else {
        return devlopConfigAPi.put(`CaseManagement/Cases/Case`, obj)
    }
}

const apicallsForCases = { casesTemplate, assignAdmins, adminData, createCase }

export default apicallsForCases